// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3Z_QA","btnRed":"styles_btnRed__2WJdp","container":"styles_container__2VCwc","body":"styles_body__lSiWk","content":"styles_content__1f4C5"};